import * as React from 'react';

import MerchantNameAndAvatar from '../../../MerchantNameAndAvatar';

interface IMerchant {
  id: string;
  name: string;
  logoUrl?: string | null;
}

interface IMerchantPrimaryElementProps {
  merchant?: IMerchant | null;
  fallbackDescription?: string;
  secondaryText?: React.ReactNode;
  /** When set, replaces the merchant name as the primary line; the avatar still derives from `merchant`. */
  displayNameOverride?: string;
}

const MerchantPrimaryElement = ({
  merchant,
  fallbackDescription,
  secondaryText,
  displayNameOverride,
}: IMerchantPrimaryElementProps) => {
  return (
    <MerchantNameAndAvatar
      merchant={merchant}
      fallbackDescription={fallbackDescription}
      secondaryText={secondaryText}
      displayNameOverride={displayNameOverride}
    />
  );
};

export default MerchantPrimaryElement;
